module.exports = __webpack_public_path__ + "img/image_108.b78b64d1.png";